import React from "react";
import "./tile.css";

const Tile  = (props: any) => {
    return <div className={"tile " + props.align + " " + props.color}>
        {props.children}
    </div>
}

export { Tile };